<script lang="ts">
  import { getContext } from "svelte";
  import { fadeSlide } from "../utils/transition";
  import { circInOut } from "svelte/easing";

  import type { StepperControl, Step } from "./Stepper.svelte";

  export let name: string;
  export let hidden: boolean = false;

  let stepper = getContext<StepperControl>("stepper");
  let step = stepper.registerStep({ name, hidden });
  stepper.changes.subscribe((_) => (stepper = stepper));
</script>

<div class="stepper-step">
  {#if stepper.step == step.number}
    <div transition:fadeSlide={{ duration: 0, easing: circInOut }}>
      <slot {stepper} />
    </div>
  {/if}
</div>
